export default {
      id: "list_sorting-usage",
      viewBox: "0 0 21.942 23",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#list_sorting-usage",
      toString: function () {
        return this.url;
      }
    }